var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSparkle01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon_sparkle01_svg__a)",
  d: "M8.493 2.776c.241-.534 1.083-.542 1.334-.013.568 1.2 1.441 2.802 2.43 3.758.892.862 2.323 1.63 3.437 2.15.535.25.525 1.105-.015 1.344-1.112.492-2.535 1.223-3.421 2.065-.991.942-1.844 2.528-2.406 3.749-.25.544-1.133.533-1.37-.018-.497-1.15-1.24-2.612-2.117-3.508-.925-.947-2.471-1.744-3.672-2.269-.55-.24-.556-1.124-.01-1.371 1.135-.513 2.571-1.271 3.46-2.142.972-.951 1.809-2.546 2.35-3.745",
  opacity: 0.8
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon_sparkle01_svg__b)",
  d: "M15.03 12.04c.123-.263.545-.267.673-.005.242.495.59 1.11.983 1.49.35.337.894.642 1.348.86.265.128.26.558-.007.68-.453.208-.994.498-1.341.828-.39.37-.731.976-.97 1.477-.127.27-.571.263-.693-.01-.21-.467-.505-1.021-.848-1.372-.364-.372-.953-.69-1.443-.913-.272-.123-.276-.567-.005-.694.46-.216 1.005-.516 1.353-.857.384-.376.72-.989.95-1.483"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_sparkle01_svg__a",
  x1: 13.233,
  x2: 5.057,
  y1: 13.449,
  y2: 5.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6B26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFAD08"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_sparkle01_svg__b",
  x1: 17.101,
  x2: 13.617,
  y1: 12.992,
  y2: 16.476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF554F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8058"
})))));
export default SvgIconSparkle01;